module.exports = __webpack_public_path__ + "static/media/promo-da-semana.f082f5b5.jpg";